import React, { useState } from "react";
import chatIcon from "../../Assets/images/other/chat-icon.png";
import chatIconWhatsapp from "../../Assets/images/other/whatsapp.png";
import chatIconfacebook from "../../Assets/images/other/facebook.png";
import chatIconteams from "../../Assets/images/other/teams.png";
import emailIcon from "../../Assets//images/other/email.png";
import videochat from "../../Assets/images/other/videochat.png";
import chatbot from "../../Assets/images/other/chatbot.png";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { motion } from "framer-motion";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import { IoMdDoneAll } from "react-icons/io";
import { RiServerFill } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
import { IoLanguage } from "react-icons/io5";
import { GiSkills } from "react-icons/gi";
import { IoIosTimer } from "react-icons/io";
import { HiOutlineMail } from "react-icons/hi";
import { MdOutlineTransferWithinAStation } from "react-icons/md";
import {
  setExternalChatData,
  setsidebarVal,
  setValue,
  setChatSessionId,
  RemoveAcceptedChat,
  AddChatToExternalContactList,
  setUserlistShow,
  setCurrentTab,
  updateStatus,
  setTypedMessage,
} from "../../Redux/Actions/actions";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toaststyle } from "../../Utils/toaststyle";

const mapStateToProps = (state) => {
  return {
    contactList2: state.data.contactList2,
  };
};

const NewIncomingRequest = (props) => {
  const navigate = useNavigate();
  const [loadingClients, setLoadingClients] = useState({}); // Track loading state for each client

  const acceptClient = async (client) => {
    setLoadingClients((prev) => ({ ...prev, [client.id]: true }));
    const datas = await JSON.parse(localStorage.getItem("tokenAgent"));
    axios
      .post(
        `${BaseUrl}/users/agentConfirmation?agent_id=${datas.id}&client_id=${client.id}&status=Accept&user_id=${datas.user_id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setLoadingClients((prev) => ({ ...prev, [client.id]: false }));
          if (localStorage.getItem("AgentStatus") == "Ready") {
            props.updateStatus("Ready");
          }
          props.RemoveAcceptedChat(client);
          localStorage.setItem("client", JSON.stringify(res.data.data[0]));
          props.setExternalChatData({ ...res.data.data[0], draftMessage: "" });
          props.setTypedMessage("");
          props.setChatSessionId(res.data.data[0].chat_session_id);
          props.AddChatToExternalContactList(res.data.data[0]);
          props.setValue(0);
          props.setUserlistShow(true);
          props.setCurrentTab("customerDetails");
          props.setsidebarVal("Chat");
          navigate("/main/Chat");
        } else {
          setLoadingClients((prev) => ({ ...prev, [client.id]: false }));
        }
      })
      .catch((err) => {
        setLoadingClients((prev) => ({ ...prev, [client.id]: false }));
      });
  };

  const rejectchat = async (
    chat_session_id,
    agentid,
    id,
    skillset,
    language,
    phone,
    channel,
    client
  ) => {
    let userId = JSON.parse(localStorage.getItem("tokenAgent"));
    axios
      .post(
        BaseUrl + "/users/rejectchat",
        {
          chat_session_id: chat_session_id,
          userID: userId.user_id,
          agentID: agentid,
          skillset: skillset,
          language: language,
          phone: phone,
          channel: channel,
          session_id: id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          props.RemoveAcceptedChat(client);
          if (localStorage.getItem("AgentStatus") == "Ready") {
            props.updateStatus("Ready");
          }
        }
      })
      .catch((err) => {});
  };

  const newincomingCrmpopupApi = async (client) => {
    let body = {
      phonenumber: client.phonenumber,
      skillset: client.skillset,
      channel: client.channel,
      direction: "INBOUND",
    };
    await axios
      .post(BaseUrl + "/ticket/crmscreenpop", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        window.open(res.data.data);
        toast.success("screen pop url generated", toaststyle);
      })
      .catch((error) => {
        console.log("error", error);
        toast.warning("screen pop url not generated", toaststyle);
      });
  };

  return (
    <>
      {props.contactList2.map((client) => (
        <motion.div
          key={client.id}
          drag
          dragConstraints={props.referance}
          className="chatrequestbox"
        >
          <Grid container>
            {/* chat details start here */}
            <Grid container alignItems={"center"} gutterBottom>
              {/* Client Avatar and Info */}
              <Grid item md={2.5} sx={{ position: "relative" }}>
                <Avatar
                  className="avatar_img"
                  sx={{
                    width: "3rem",
                    height: "3rem",
                    background: "white",
                    zIndex: "999",
                  }}
                  src={(() => {
                    switch (client.channel) {
                      case "webchat":
                        return chatIcon;
                      case "from_whatsapp":
                        return chatIconWhatsapp;
                      case "from_facebook":
                        return chatIconfacebook;
                      case "from_teams":
                        return chatIconteams;
                      case "videochat":
                        return videochat;
                      case "from_purple":
                        return chatbot;
                      default:
                        return emailIcon;
                    }
                  })()}
                />
              </Grid>
              <Grid item md={9.5}>
                <Stack
                  direction={"row"}
                  justifyContent={"start"}
                  alignItems={"flex-end"}
                >
                  <Typography variant="subtitle2" sx={{ fontSize: "0.675rem" }}>
                    {(() => {
                      switch (client.channel) {
                        case "email":
                          return client.transferred
                            ? `Email transferred from ${client.previous_agent.username}`
                            : `Email Request From ${client.email}`;
                        case "videochat":
                          return `Video chat Request From ${client.email}`;
                        default:
                          return client.transferred
                            ? `Chat transferred from ${client.previous_agent.username}`
                            : `Chat Request From ${
                                client.unique_id.username ||
                                client.unique_id.email
                              }`;
                      }
                    })()}
                  </Typography>
                </Stack>
                {/* Additional info */}
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"flex-start"}
                  flexWrap={"wrap"}
                >
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#d9d9d9", fontSize: "0.65rem" }}
                  >
                    <GiSkills className="me-1" />
                    {client.skillset}
                  </Typography>
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#d9d9d9", fontSize: "0.65rem" }}
                  >
                    <IoLanguage className="me-1" />
                    {client.language}
                  </Typography>
                  {client.transferred ? (
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{ color: "#d9d9d9", fontSize: "0.65rem" }}
                    >
                      <MdOutlineTransferWithinAStation className="me-1" />
                      {client.unique_id.username || client.unique_id.email}
                    </Typography>
                  ) : (
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{ color: "#d9d9d9" }}
                    >
                      {client.rescheduleflag ? (
                        <>
                          <HiOutlineMail className="me-1" />
                          "Rescheduled Email"
                        </>
                      ) : (
                        <>
                          <IoIosTimer className="me-1" />
                          {moment(client.arrival_at).fromNow()}
                        </>
                      )}
                    </Typography>
                  )}
                </Stack>
              </Grid>
            </Grid>
            {/* Call controller start here */}
            <Box className="btn-group w-100 mt-3" role="group">
              {/* Accept button */}
              <button
                type="button"
                style={{ background: "#2980B7" }}
                disabled={loadingClients[client.id] ? true : false}
                className="btn call-btn fs-11"
                onClick={() => acceptClient(client)}
              >
                {loadingClients[client.id] ? (
                  <span className="accepting-text">
                    Accepting
                    <span className="dots">
                      <span>.</span>
                      <span>.</span>
                      <span>.</span>
                      <span>.</span>
                    </span>
                  </span>
                ) : (
                  <>
                    <IoMdDoneAll className="me-1" />
                    Accept
                  </>
                )}
              </button>

              {/* Reject button */}
              {JSON.parse(localStorage.getItem("permission")).map((module) => {
                if (module.moduleName === "INTERACTION") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      (item.screenId === "REJECT_CHAT"&& item.read && item.write) ||
                     ( item.screenId === "REJECT_PURPLE"&& item.read && item.write )
                  );

                  if (crmScreen) {
                    return (
              <button
                type="button"
                className="btn call-btn bg-danger fs-11"
                onClick={() => {
                  rejectchat(
                    client.chat_session_id,
                    client.agent,
                    client.id,
                    client.skillset,
                    client.language,
                    client.phonenumber,
                    client.channel,
                    client
                  );
                }}
              >
                <IoMdClose className="me-1" />
                Reject
              </button>
 );
}
}
return <></>;
})}
              {/* CRM button */}
              {JSON.parse(localStorage.getItem("permission")).map((module) => {
                if (module.moduleName === "INTERACTION") {
                  const crmScreen = module.screen.find(
                    (item) =>
                      (item.screenId === "CRM_CHAT"&& item.read && item.write) ||
                     ( item.screenId === "CRM_PURPLE"&& item.read && item.write )||
                      (item.screenId === "CRM_EMAIL" && item.read && item.write)
                  );

                  if (crmScreen) {
                    return (
                      <button
                        type="button"
                        className="btn call-btn bg-secondary fs-11"
                        onClick={() => {
                          newincomingCrmpopupApi(client);
                          acceptClient(client);
                        }}
                      >
                        <RiServerFill className="me-1" /> CRM
                      </button>
                    );
                  }
                }
                return <></>;
              })}
            </Box>
          </Grid>
        </motion.div>
      ))}
    </>
  );
};

export default connect(mapStateToProps, {
  setExternalChatData,
  setsidebarVal,
  setValue,
  setChatSessionId,
  RemoveAcceptedChat,
  AddChatToExternalContactList,
  setUserlistShow,
  setCurrentTab,
  updateStatus,
  setTypedMessage,
})(NewIncomingRequest);
